module.exports = __webpack_public_path__ + "img/tarj2-3.4b03646a.png";